import './App.css';
import { useNavigate } from 'react-router-dom';

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1>// Privacy Policy</h1>
      <div className="profile-comment"># What we store and why</div>

      <div className="faq-content">
        <div className="faq-back">
          <button onClick={() => navigate('/')} className="back-button">
            ← Back to Home
          </button>
        </div>

        <div className="faq-item">
          <p className="faq-answer">
            player.properties has no accounts, no login and no cookies. We store
            two things: anonymous usage analytics, and snapshots of public CS2
            inventories. Both are described below.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Inventory snapshots</h2>
          <p className="faq-answer">
            When a profile with a public CS2 inventory is looked up, we store a
            snapshot: the Steam64 ID, the time, the item list and its estimated
            value. We use snapshots to build aggregate statistics, such as value
            distributions across players.
          </p>
          <ul className="faq-list">
            <li>Snapshots are never published per player.</li>
            <li>Raw snapshots are deleted after 12 months.</li>
            <li>Aggregate statistics derived from them contain no Steam IDs and are kept indefinitely.</li>
            <li>Private inventories are never snapshotted.</li>
            <li>To stop new snapshots, set your Steam inventory to private.</li>
            <li>To have existing snapshots of your Steam ID deleted, send a request through the <a href="/feedback">feedback page</a>.</li>
          </ul>
          <p className="faq-answer">
            To keep load on Steam low, an inventory is also cached on Cloudflare
            for up to 48 hours (12 hours if private).
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Analytics</h2>
          <p className="faq-answer">
            We use privacy-friendly, cookieless, self-hosted analytics (Umami) to
            measure aggregate usage — page views and feature clicks — so we know
            what's useful. Inventory values are recorded only as coarse ranges,
            never exact amounts.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">Affiliate links</h2>
          <p className="faq-answer">
            The CSFloat buttons are affiliate links. When you click one, CSFloat
            sees you came from player.properties. We share nothing else with them.
          </p>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">What we don't do:</h2>
          <ul className="faq-list">
            <li>No cookies</li>
            <li>No third-party ad or cross-site tracking</li>
            <li>No user accounts</li>
            <li>No selling or sharing of data</li>
          </ul>
        </div>

        <div className="faq-item">
          <h2 className="faq-question">What happens when you visit:</h2>
          <p className="faq-answer">
            When you visit, your browser makes a request to our Cloudflare Workers.
            Cloudflare may log basic request info (IP, timestamp) per their policy.
          </p>
          <p className="faq-answer" style={{ marginTop: '20px', fontStyle: 'italic', opacity: 0.7 }}>
            Last updated: September 2026
          </p>
        </div>
      </div>

      <div className="footer">
        <a href="/faq" className="faq-link">FAQ</a> • <a href="/privacy" className="faq-link">Privacy</a> • <a href="/feedback" className="faq-link">Feedback</a> • Built by a CS player who got tired of copy-pasting Steam IDs • Runs on Cloudflare Workers
      </div>
    </div>
  );
}

export default Privacy;
